export function getBedbankLocationHeading(offer: App.BedbankOffer) {
  return [offer.property.address.city, offer.property.address.stateProvinceName].filter(Boolean).join(', ')
}

export const getBedbankPriceAndValue =
  (hotelOnlyRates: App.BedbankRate[], showTaxExclusivePrices: boolean, roomId: string | undefined):
  {price?: number, value?: number, isExclusivePrice?: boolean} => {
    const rate = hotelOnlyRates.find(rate => !roomId || rate.roomId === roomId)
    if (!rate) {
      return {}
    }
    const propertyFees = rate.totals.propertyFees ?? 0
    const inclusivePrice = rate.totals.inclusive + propertyFees
    return {
      price: showTaxExclusivePrices ? rate.totals.exclusive : inclusivePrice,
      value: rate.value,
      isExclusivePrice: showTaxExclusivePrices && rate.totals.exclusive !== inclusivePrice,
    }
  }

export function getBedbankFacilitiesLimit(tagline: boolean, promotionsLength: number) {
  let limitNumberOfFacilities = 5
  if (tagline) limitNumberOfFacilities = limitNumberOfFacilities - 3
  if (promotionsLength) limitNumberOfFacilities = Math.round(limitNumberOfFacilities - (promotionsLength * 1.5))
  limitNumberOfFacilities = limitNumberOfFacilities > 0 ? limitNumberOfFacilities : 0

  return limitNumberOfFacilities
}
